type CategoryName = 'Analytics' | 'Functional';

export async function getConsentCategoryState(categoryName: CategoryName) : Promise<boolean> {
  try {
    // eslint-disable-next-line no-underscore-dangle
    const details = await window.__ucCmp.getConsentDetails();

    for (const category of Object.values(details.categories)) {
      if (category.name === categoryName) {
        return category.state === 'ALL_ACCEPTED';
      }
    }

    return false;
  } catch {
    return false;
  }
}
